var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriveLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.33 57.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.54,
    y: 26.85,
    width: 5.92,
    height: 2.96,
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.54,
    y: 20.94,
    width: 5.92,
    height: 2.96,
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.21,41.65H13.67v-2.96h2.96V16.5c0-.82,.66-1.48,1.48-1.48h14.79c.82,0,1.48,.66,1.48,1.48v22.19h2.96v-14.79h4.44c.82,0,1.48,.66,1.48,1.48v13.31h2.96v2.96ZM28.67,0C12.83,0,0,12.83,0,28.67s12.83,28.66,28.67,28.66c15.82-.02,28.65-12.84,28.66-28.66C57.33,12.83,44.5,0,28.67,0",
    style: {
      fill: "#c42032"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveLocal);
export default __webpack_public_path__ + "static/media/DriveLocal.2acadf8e909b1748006eb5cdab71d2d0.svg";
export { ForwardRef as ReactComponent };